import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const FileIcon = ({
  width = "32",
  height = "32",
  color = "#4C545B",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4441_31051)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.6673 2.66406L26.6673 10.6641V26.6641C26.6675 27.3368 26.4134 27.9848 25.956 28.4781C25.4985 28.9714 24.8715 29.2736 24.2006 29.3241L24.0007 29.3307H8.00065C7.32788 29.3309 6.6799 29.0769 6.18659 28.6194C5.69328 28.1619 5.39111 27.5349 5.34065 26.8641L5.33398 26.6641V5.33073C5.33377 4.65796 5.58786 4.00997 6.04531 3.51667C6.50277 3.02336 7.12978 2.72119 7.80065 2.67073L8.00065 2.66406H18.6673ZM17.318 5.33073H8.00065V26.6641H24.0007L24.01 11.9974H19.3273C18.8301 11.9974 17.3273 11.9974 17.3273 11.9974V11.5227L17.318 11.3307V5.33073Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4441_31051">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
};
